export default from './ResultsTable'


// WEBPACK FOOTER //
// ./src/components/Modules/ResultsTable/index.js